import cn from 'classnames';
import { Heading, P, Section, Wrapper } from 'components/base';
import Label from 'components/Label';
import { Link } from 'gatsby';
import isEmpty from 'lodash-es/isEmpty';
import PropTypes from 'prop-types';
import React from 'react';
import { bHeading, bImage, desc2, hasImageC, heading as headingC, image, item, subheading as subheadingC, wrapper as wrapperC } from './FeaturesList.module.scss';

const Item = ({ heading, description, description2, subheading, img, label, linkTo }) => {
  const hasImage = !isEmpty(img);
  return (
    <div className={item}>
      { hasImage &&  <div className={bImage}>
        <img src={img.publicURL} className={image} />
      </div>}
      <div className={cn({ hasImage: hasImageC }, bHeading)}>
        <Heading
          Tag="h3"
          size="SM"
          marginBottom="Xxs"
          bold
          className={headingC}
        >
          {heading}
          {label && <Label type="New" text="hot" />}
        </Heading>
        { subheading && <P Tag="h4" bold className={subheadingC}>{subheading}</P>}
        <P Tag="h4">
          {description}
          {!isEmpty(linkTo) && <span><Link to={linkTo} className="text-link-sky">更多介紹</Link></span>}
        </P>
        { !isEmpty(description2) && <P Tag="h4" className={desc2}>{description2}</P> }
      </div>
    </div>
  )
};
Item.propTypes = {
  heading: PropTypes.string.isRequired,
  subheading: PropTypes.string,
  description: PropTypes.string,
  description2: PropTypes.string,
  img: PropTypes.object,
  label: PropTypes.bool,
  linkTo: PropTypes.string,
};
Item.defaultProps = {
  label: false,
  description2: '',
  subheading: null,
  img: null,
  linkTo: null
};

const FeaturesList = ({ data, padding, theme }) => (
  <Section padding={padding} theme={theme}>
    <Wrapper size="ML">
      <div className={wrapperC}>
        {data.map((props, i) => (
          <Item {...props} key={i} />
        ))}
      </div>
    </Wrapper>
  </Section>
);
FeaturesList.propTypes = {
  data: PropTypes.array.isRequired,
  padding: PropTypes.string,
  theme: PropTypes.string,
};
FeaturesList.defaultProps = {
  data: [],
  padding: 'None',
  theme: 'Blue',
}

export default FeaturesList;
